export enum AnnouncementEventType {
  UTWORZENIE_KOMUNIKATU = 'Utworzenie komunikatu',
  EDYCJA_KOMUNIKATU = 'Edycja komunikatu',
  OPUBLIKOWANIE_KOMUNIKATU = 'Opublikowanie komunikatu',
  ARCHIWIZACJA_KOMUNIKATU = 'Archiwizacja komunikatu',
}
